module.exports = __webpack_public_path__ + "static/media/DWK_01.434801de.jpg";